import type { EntryPointComponent } from 'react-relay';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { serviceDeskContextResource } from '@jira/router-resources__service-desk-context/src/serviceDeskContextResource.tsx';
import { incidentCommandCenterFeatureResource } from '@jira/router-resources__incident-command-center-feature/src/incidentCommandCenterFeatureResource.tsx';
import { projectSettingsServicedeskIncidentManagementRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskIncidentManagementRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import type { Route } from '@atlassian/react-resource-router';
import { fg } from '@atlassian/jira-feature-gating';
import ServiceDeskIncidentManagementSettings, {
	LazyProjectSettingsServiceDeskIncidentManagement,
} from './ui/service-desk-incident-management/index.tsx';

const getIncidentCommandCenterFeatureResources = () =>
	fg('jsm_incident_command_center') ? [incidentCommandCenterFeatureResource] : [];

const projectSettingsServicedeskIncidentManagementPageEntryPoint = createPageEntryPoint({
	main: {
		root: JSResourceForUserVisible<EntryPointComponent<{}, {}, {}, {}>>(
			/* webpackChunkName: "async-project-settings-service-desk-incident-management", jiraSpaEntry: "async-project-settings-service-desk-incident-management" */ '@jira/spa-apps__project-settings-service-desk-incident-management-settings/src/ServiceDeskIncidentManagementSettingsPage.tsx',
			{ entryFsSsrLiftImportToModule: false },
		),
		getPreloadProps: () => ({}),
	},
});

export const projectSettingsServicedeskIncidentManagementRouteEntry: Route = createEntry(
	projectSettingsServicedeskIncidentManagementRoute,
	() => ({
		group: 'project-settings-servicedesk',

		// eslint-disable-next-line no-restricted-syntax
		component: fg('nike_entrypoint_migration_batch_2')
			? undefined
			: ServiceDeskIncidentManagementSettings,

		entryPoint: () =>
			fg('nike_entrypoint_migration_batch_2')
				? projectSettingsServicedeskIncidentManagementPageEntryPoint
				: undefined,
		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		resources: [
			...getServiceDeskSettingsResources(),
			serviceDeskContextResource,
			getConsolidationStateResource(),
			...getIncidentCommandCenterFeatureResources(),
		],

		forPaint: [LazyAtlassianNavigation, LazyProjectSettingsServiceDeskIncidentManagement],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
